import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

export const Button = ({ children, variant = 'jade', className = '', ...props }) => (
  <button
    className={`${variant === 'jade' ? 'btn-jade' : 'btn-ghost'} px-6 py-3 text-sm inline-flex items-center justify-center gap-2 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const Card = ({ children, className = '', hover = false, ...props }) => (
  <div className={`card ${hover ? 'card-hover' : ''} ${className}`} {...props}>
    {children}
  </div>
);

export const Badge = ({ children, tone = 'jade', className = '' }) => {
  const tones = {
    jade: 'text-jade border-jade/40 bg-jade/10',
    amber: 'text-amber border-amber/40 bg-amber/10',
    crimson: 'text-crimson border-crimson/40 bg-crimson/10',
    slate: 'text-slate-300 border-white/15 bg-white/5',
  };
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-xs font-mono uppercase tracking-wider ${tones[tone]} ${className}`}>
      {children}
    </span>
  );
};

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="block text-xs font-mono uppercase tracking-wider text-slate-400 mb-1.5">{label}</span>
    {children}
  </label>
);

export const Input = (props) => (
  <input className="input w-full px-4 py-3 text-sm" {...props} />
);

export const Select = ({ children, ...props }) => (
  <select className="input w-full px-4 py-3 text-sm" {...props}>{children}</select>
);

export const Spinner = ({ label }) => (
  <div className="flex items-center gap-3 text-slate-300 text-sm">
    <Loader2 className="w-4 h-4 animate-spin text-jade" /> {label}
  </div>
);

export const Stepper = ({ steps, current }) => (
  <div className="flex items-center gap-2 flex-wrap mb-8">
    {steps.map((s, i) => (
      <React.Fragment key={s}>
        <div className={`flex items-center gap-2 ${i <= current ? 'text-jade' : 'text-slate-500'}`}>
          <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-mono border ${i < current ? 'bg-jade text-ink border-jade' : i === current ? 'border-jade' : 'border-white/15'}`}>
            {i + 1}
          </span>
          <span className="text-xs font-mono uppercase tracking-wider hidden sm:inline">{s}</span>
        </div>
        {i < steps.length - 1 && <div className={`h-px w-6 ${i < current ? 'bg-jade' : 'bg-white/10'}`} />}
      </React.Fragment>
    ))}
  </div>
);

export const Reveal = ({ children, delay = 0, className = '' }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
